import _ from 'lodash';
import ah from '../utils/ajax-helper';
import { PAGESITS } from '../consts/display';
import i18n from 'i18next';
var t = i18n.getFixedT(null, 'app'); // NVR ----------
// get nvr list

export var getNvrList = function getNvrList(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword
    };
    ah.get("".concat(contextRoot, "/nvr/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // create nvr

export var createNvrAPI = function createNvrAPI(contextRoot, noProgress, nvrData) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/nvr/create"), JSON.stringify(nvrData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit nvr

export var editNvrAPI = function editNvrAPI(contextRoot, noProgress, nvrData) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/nvr/edit"), JSON.stringify(nvrData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete nvr

export var deleteNvrAPI = function deleteNvrAPI(contextRoot, noProgress, deleteItems) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/nvr/delete"), JSON.stringify(deleteItems), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete multiple nvr

export var deleteMultipleNVRAPI = function deleteMultipleNVRAPI(contextRoot, noProgress, deleteItems) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/nvr/delete/all"), JSON.stringify(deleteItems), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // ----------
// get audit log

export var getAuditLogList = function getAuditLogList(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var dateTime = arguments.length > 3 ? arguments[3] : undefined;
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var moduleName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'dateTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      // keyword: keyword,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59',
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit,
      'module-name': moduleName
    };
    ah.get("".concat(contextRoot, "/audit-log/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // ----------
// billboard api

export var getBillboardList = function getBillboardList(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 10;
  var billboardTypeId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'beginTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      billboardTypeId: billboardTypeId
    };
    ah.get("".concat(contextRoot, "/billboard/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getBillboardMessageList = function getBillboardMessageList(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 10;
  var billboardTypeId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'beginTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      billboardTypeId: billboardTypeId
    };
    ah.get("".concat(contextRoot, "/billboard/messages"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // create billboard

export var createBillboardAPI = function createBillboardAPI(contextRoot, noProgress, billboardJson, billboardForm) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/billboard/create"), JSON.stringify(billboardJson), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      return result;
    }).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      billboardForm.append("id", result.data.value);
      return fetch("".concat(contextRoot, "/billboard/upload"), {
        method: 'POST',
        body: billboardForm
      });
    }).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit billboard

export var editBillboardAPI = function editBillboardAPI(contextRoot, noProgress, billboardJson, billboardForm) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/billboard/edit"), JSON.stringify(billboardJson), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      return result;
    }).then(function (result) {
      if (result.code < 0) throw new Error(result.error);

      if (billboardForm) {
        billboardForm.append("id", billboardJson.id);
        return fetch("".concat(contextRoot, "/billboard/upload"), {
          method: 'POST',
          body: billboardForm
        });
      }

      return result;
    }).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete multiple billboard

export var deleteMultipleBillboardAPI = function deleteMultipleBillboardAPI(contextRoot, noProgress, deleteItems) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/billboard/delete/all"), JSON.stringify(deleteItems), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get billboard type list

export var getBillboardTypeList = function getBillboardTypeList(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/billboard/type/list/all"), null, null, noProgress).then(function (result) {
      if (result.code < 0) {
        throw new Error(result.error);
      }

      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // create billboard type

export var createBillboardTypeAPI = function createBillboardTypeAPI(contextRoot, noProgress, _ref) {
  var name = _ref.name;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/billboard/type/create"), JSON.stringify({
      name: name
    }), null, noProgress).then(function (result) {
      if (result.code < 0) {
        throw new Error(result.error);
      }

      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var editBillboardTypeAPI = function editBillboardTypeAPI(contextRoot, noProgress, _ref2) {
  var id = _ref2.id,
      name = _ref2.name;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/billboard/type/edit"), JSON.stringify({
      id: id,
      name: name
    }), null, noProgress).then(function (result) {
      if (result.code < 0) {
        throw new Error(result.error);
      }

      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var deleteBillboardTypeAPI = function deleteBillboardTypeAPI(contextRoot, noProgress, typeId) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/billboard/type/delete"), JSON.stringify({
      id: typeId
    }), null, noProgress).then(function (result) {
      if (result.code < 0) {
        throw new Error(result.error);
      }

      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // ----------
// terminal board list

export var getTerminalBoardList = function getTerminalBoardList(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 10;
  var terminalId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'beginTime';
    sortField = sortField == 'terminalId' ? 'terminal.name' : sortField;
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      terminalId: terminalId
    };
    ah.get("".concat(contextRoot, "/terminalBoard/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getTerminalBoardMessageList = function getTerminalBoardMessageList(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 10;
  var terminalId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'beginTime';
    sortField = sortField == 'terminalId' ? 'terminal.name' : sortField;
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      terminalId: terminalId
    };
    ah.get("".concat(contextRoot, "/terminalBoard/messages"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // create terminal board

export var createTerminalBoardAPI = function createTerminalBoardAPI(contextRoot, noProgress, terminalBoardJson, terminalBoardForm) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/terminalBoard/create"), JSON.stringify(terminalBoardJson), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      return result;
    }).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      terminalBoardForm.append("id", result.data.value);
      return fetch("".concat(contextRoot, "/terminalBoard/upload"), {
        method: 'POST',
        body: terminalBoardForm
      });
    }).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit terminal board

export var editTerminalBoardAPI = function editTerminalBoardAPI(contextRoot, noProgress, terminalBoardJson, terminalBoardForm) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/terminalBoard/edit"), JSON.stringify(terminalBoardJson), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      return result;
    }).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      terminalBoardForm.append("id", terminalBoardJson.id);
      return fetch("".concat(contextRoot, "/terminalBoard/upload"), {
        method: 'POST',
        body: terminalBoardForm
      });
    }).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
  return new Promise(function (resolve, reject) {
    fetch("".concat(contextRoot, "/terminalBoard/edit"), {
      method: 'POST',
      body: terminalBoardData
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.code < 0) throw result;
      resolve();
    }).catch(function (error) {
      reject(error);
    }); // ah.post(`${contextRoot}/terminalBoard/edit`, JSON.stringify(terminalBoardData), null, noProgress).then(result => {
    //     if (result.code < 0)
    //         throw new Error(result.error)
    //     resolve()
    // }).catch(error => {
    //     reject(error)
    // })
  });
}; // delete multiple terminal board

export var deleteMultipleTerminalBoardAPI = function deleteMultipleTerminalBoardAPI(contextRoot, noProgress, deleteItems) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/terminalBoard/delete/all"), JSON.stringify(deleteItems), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // ----------
// feedback

export var editFeedbackAPI = function editFeedbackAPI(contextRoot, noProgress, description) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/system-config/feedback.description"), _.toString(description), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getFeedbackDescriptionAPI = function getFeedbackDescriptionAPI(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/system-config/feedback.description"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data.value.value);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // ----------
// audit-log statistics

function getKey() {
  var _window = window,
      location = _window.location;
  if (!location) return null;

  var currentPage = _(PAGESITS).filter(function (val) {
    if (location.pathname.indexOf(val.url) >= 0) return true;
    return false;
  }).sortBy(function (el) {
    return 0 - el.url.length;
  }).take(1).value();

  if (currentPage && currentPage[0]) {
    var urlComps = _.filter(currentPage[0].url.split('/'), function (el) {
      return el;
    });

    var lngKey = '';

    if (urlComps.length > 1) {
      lngKey = urlComps.join('.');
    } else if (urlComps.length === 1) {
      lngKey = "".concat(urlComps[0], ".title");
    }

    lngKey = "menu.side.".concat(lngKey);
    if (i18n.exists(lngKey, {
      ns: 'app'
    })) return t(lngKey);else return '';
  }

  return null;
}

export var postAuditLogStatistics = function postAuditLogStatistics(contextRoot, noProgress, target, targetType) {
  var moduleName = getKey(); // targetType: HOME_TERMINAL/MAP_GATE/MAP_TERMINAL/MAP_CAMERA/MAP_VD或不給

  return new Promise(function (resolve, reject) {
    return ah.post("".concat(contextRoot, "/audit-log/create"), JSON.stringify({
      moduleName: moduleName,
      actionName: t("logger.action-view"),
      target: target,
      targetType: targetType,
      actionResult: 0,
      severity: 1
    }), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (err) {
      console.error(err);
      reject();
    });
  });
};
export var getAuditLogStatistics = function getAuditLogStatistics(contextRoot, noProgress, moduleType, targetType, dateTime) {
  var keyword = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var sort = arguments.length > 6 ? arguments[6] : undefined;
  var offset = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
  var limit = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'count';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      targetType: targetType,
      moduleType: moduleType,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59',
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword
    };
    return ah.get("".concat(contextRoot, "/audit-log-target-statistics/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}; // ----------